import { setIsDiscountOfferModalVisible } from "~/solidJs/shared/models/globalStores";
export type DiscountOfferModalVariants = {
	isVisible: boolean;
	headerText: string;
	promoCode: string;
};
export const DiscountOfferModalVariants = {
	/**
	 * Special 24-hour offer shown to basic users on their 3rd session
	 * Provides 10% discount on any subscription plan
	 */
	sessionOffer: {
		isVisible: true,
		headerText: "Special limited 24h offer! 10% off any plan",
		promoCode: "POWER"
	},
	/**
	 * One-time offer shown to basic users when they reach their usage limit
	 * Provides 15% discount on any subscription plan
	 * Only shows once and is tracked in localStorage
	 */
	limitOffer: {
		isVisible: true,
		headerText: "Continue creating! Your special offer – 15% off any plan",
		promoCode: "SUPER"
	},
	/**
	 * Time-based offer shown to basic users after 7 minutes of usage
	 * Provides 10% discount on any subscription plan
	 */
	timetOffer: {
		isVisible: true,
		headerText: `Unlock more features!
		Your special offer – 10 % off any plan`,
		promoCode: "START"
	},
	/**
	 * Offer shown to basic users when they have used 9 out of their total available runs
	 * Encourages users to upgrade to save their projects and access more features
	 */
	saveTipOffer: {
		isVisible: true,
		headerText: `Save your creations!
		Unlock projects and more features`,
		promoCode: "SAVES"
	}
} as const;
// sessionCounter.timeCounter.addCallbackToTime(60 * 7 * 1000, () => {
// 	const group = getUserStore()?.group;
// 	if (group !== "basic") return;
// 	setIsDiscountOfferModalVisible(DiscountOfferModalVariants.timetOffer);
// });

export const isLimitOffer = () => {
	const prev = localStorage.getItem("limitOffer");
	if (prev) return false;
	localStorage.setItem("limitOffer", "true");
	setIsDiscountOfferModalVisible(DiscountOfferModalVariants.limitOffer);
};
